import { useState, useEffect } from "react";
import React from "react";
import { toast } from 'react-toastify';
import { useNavigate, useParams } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import { API_FACTURAS_DESGUACES } from '../shared/services/facturas_desguaces';
import Header from '../shared/components/Header'
import moment from 'moment';
import { useDispatch, useSelector } from "react-redux";
import { fetchFacturasDesguaces } from "../../../../redux/facturasDesguaces";
import ActionsMenu from "../shared/components/ActionsMenu";
import FacturaModal from "./components/FacturaModal";
import { getActions } from "./actions";
import DevolucionesModal from "./components/DevolucionesModal";
import InfoModal from "../shared/components/InfoModal";
import { setErrorMessage } from "../shared/helpers/functionalities";

export default function FacturasDesguaces() {
  const dispatch = useDispatch();
  const { page } = useParams();
  const currPage = parseInt(page);
  let navigate = useNavigate();
  const [currentPage, setPage] = useState(currPage);
  const [currentFactura, setCurrentFactura] = useState(null);
  const [openNew, setOpenNew] = useState(false);
  const [openRefund, setOpenRefund] = useState(false);
  const facturas = useSelector(state => state.facturas_desguaces);
  const searcher = useSelector(state => state.search)

  useEffect(() => {
    dispatch(fetchFacturasDesguaces(currPage, getQuery()));
  }, [searcher]);

  const getQuery = () => {
    const isEmpty = Object.values(searcher).every(x => x === null || x === '');
    let query = !isEmpty ? 'search=' + (searcher?.search ? searcher?.search : '')
    : null;

    return query;
  }

  const handleReload = () => {
    setPage(1);
    navigate(`/facturas-desguaces/${1}`);
    dispatch(fetchFacturasDesguaces(1, getQuery()));
    handleCloseNew();
  }
  
  const handleSearch = (search, searchData) => {
    setPage(1);
    navigate(`/facturas-desguaces/${1}`);
    dispatch({type: "search/set", payload: searchData});     
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    navigate(`/facturas-desguaces/${newPage}`);
    dispatch(fetchFacturasDesguaces(newPage, getQuery()));
  }

  const getPaginationCount = () => {
    var totalPages = facturas?.total_items < 15 ? 1 : Math.ceil(facturas?.total_items / 15);
    return totalPages ? parseInt(totalPages) : 0;
  }

  const handleAction = (action, factura) => {
    if(action === 'download') {
      generateThePdf(factura)
    } else  if(action === 'regenerate') {
      regenerate(factura)
    } else if(action === 'refund') {
      handleOpenRefund(factura);
    }
  }

  const regenerate = async(factura) => {
    dispatch({type: 'loading/set', payload: true});
    const response = await API_FACTURAS_DESGUACES.regenerateFactura({
      factura_id: factura.id,
      tipo: factura.bastidor === "" && factura.vehiculo === '' ? 'manual' : 'auto'
    })
    .catch(function (error) {
      dispatch({type: 'loading/set', payload: false});
      toast.error(setErrorMessage(error.message))
    });

    if(response && response.success) {
      dispatch({type: 'loading/set', payload: false});
      toast.success(response.message);
    }
  }

  const generateThePdf = async (factura) => {
      dispatch({type: 'loading/set', payload: true});
      const pdfResult = await API_FACTURAS_DESGUACES.generateFacturaPDF(factura.id);

      if(pdfResult) {
        window.open(pdfResult.data, "_blank");
      } else {
        toast.error('Ups! Algo ha ido mal...')
      }
      dispatch({type: 'loading/set', payload: false});
  }

  const handleOpenNew = () => setOpenNew(true);
  const handleCloseNew = () => setOpenNew(false);

  // DEVOLUCIONES
  const handleOpenRefund = (factura) => {
    setCurrentFactura(factura);
    setOpenRefund(true);
  }
  const handleCloseRefund = () => { setOpenRefund(false); setCurrentFactura(null); }
  const handleRefund = async(data) => {
    dispatch({type: 'loading/set', payload: true});
    const response = await API_FACTURAS_DESGUACES.refund(currentFactura.id, data)
    .catch(function (error) {
      dispatch({type: 'loading/set', payload: false});
      toast.error(setErrorMessage(error.message))
    });

    if(response && response.success) {
      toast.success(response.message);
      dispatch(fetchFacturasDesguaces(currPage, getQuery()));
    }
  }

  return (
    <div className="content pt-3">
      <Header  
        viewSearch={true}
        onSearch={handleSearch}
        onNew={handleOpenNew}
      />

      <div className="w-100 d-flex flex-column align-items-end content-table">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Nº</th>
                <th className="text-center">desguace</th>
                <th className="text-center">fecha</th>
                <th className="text-center">tipo</th>
                <th className="text-center">bastidor</th>
                <th className="text-center">vehiculo</th>
                <th className="text-center">total</th>
                <th className="text-center">I.V.A</th>
                <th className="text-center">total I.V.A</th>
                <th className="text-center"></th>
              </tr>
            </thead>

            <tbody>
              { facturas.facturas?.map((factura) => {
                return (
                  <tr key={factura.id}>
                    <td>{factura.numero}</td>
                    <td className="text-center text-uppercase fw-bold">{factura.desguace.nombre}</td>
                    <td className="text-center">{moment(factura.fecha).format("DD-MM-YYYY")}</td>
                    <td className="text-uppercase text-center">{factura.bastidor ? 'auto' : 'manual'}</td>
                    <td className="text-center">{factura.bastidor ? factura.bastidor : '-'}</td>
                    <td className="text-center">{factura.vehiculo ? factura.vehiculo : '-'}</td>
                    <td className="text-center">{parseFloat(factura.total).toFixed(2)}€</td>
                    <td className="text-center">{factura.iva}%</td>
                    <td className="text-center">{factura.total_iva}€</td>
                    <td className="text-center">
                      <ActionsMenu 
                          options={getActions(factura)}
                          onAction={(action) => handleAction(action, factura)}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <Pagination 
          className="mt-3" 
          count={getPaginationCount()} 
          page={currentPage} 
          onChange={handleChangePage} 
        />
      </div>

      { (openNew) && 
        <FacturaModal
            state={openNew}
            onReloadFacturas={handleReload}
            onClose={handleCloseNew}
        ></FacturaModal>
      }

      { (openRefund) && (
        <InfoModal
          state={openRefund}
          title={`Generar devolución de ${currentFactura?.numero}`}
          content={
            <DevolucionesModal 
              factura={currentFactura}
              onSubmitDevolucion={handleRefund}
            />
          }
          width={"md"}
          onClose={handleCloseRefund}
        />
      )}
    </div>
  )
}